module.exports = __webpack_public_path__ + "img/tutorial_one_nl.ec97dd78.png";